import update from 'immutability-helper';
import { PROGRESS, SUCCESS, FAILED } from "../config/types";
import {
  TEMPLATES_GET_LIST_PROGRESS,
  TEMPLATES_GET_LIST_SUCCESS,
  TEMPLATES_GET_LIST_FAILED,
  TEMPLATES_FORM_SUBMIT_PROGRESS,
  TEMPLATES_FORM_SUBMIT_SUCCESS,
  TEMPLATES_FORM_SUBMIT_FAILED,
  TEMPLATES_GET_TEMPLATE_PROGRESS,
  TEMPLATES_GET_TEMPLATE_SUCCESS,
  TEMPLATES_GET_TEMPLATE_FAILED,
  TEMPLATES_CLEAR_STATE,
} from "../actions/TemplatesAction";

const initialState = {
  loadListStatus: '',
  loadActiveStatus: '',
  submitStatus: '',
  list: [],
  pagination: {},
  active: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TEMPLATES_GET_LIST_PROGRESS: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: PROGRESS },
        },
      );
    }
    case TEMPLATES_GET_LIST_SUCCESS: {
      return update(
        state, {
          list: { $set: action.payload.list },
          pagination: { $set: action.payload.pagination },
          loadListStatus: { $set: SUCCESS },
        },
      );
    }
    case TEMPLATES_GET_LIST_FAILED: {
      return update(
        state, {
          list: { $set: [] },
          pagination: { $set: {} },
          loadListStatus: { $set: FAILED },
        },
      );
    }
    case TEMPLATES_FORM_SUBMIT_PROGRESS: {
      return update(
        state,
        { submitStatus: { $set: PROGRESS } },
      );
    }
    case TEMPLATES_FORM_SUBMIT_SUCCESS: {
      return update(
        state,
        {
          submitStatus: { $set: SUCCESS },
        },
      );
    }
    case TEMPLATES_FORM_SUBMIT_FAILED: {
      return update(
        state,
        { submitStatus: { $set: FAILED } },
      );
    }
    case TEMPLATES_GET_TEMPLATE_PROGRESS: {
      return update(
        state, {
          active: { $set: {} },
          loadActiveStatus: { $set: PROGRESS },
        },
      );
    }
    case TEMPLATES_GET_TEMPLATE_SUCCESS: {
      return update(
        state, {
          active: { $set: action.payload.template },
          loadActiveStatus: { $set: SUCCESS },
        },
      );
    }
    case TEMPLATES_GET_TEMPLATE_FAILED: {
      return update(
        state, {
          active: { $set: {} },
          loadActiveStatus: { $set: FAILED },
        },
      );
    }
    case TEMPLATES_CLEAR_STATE: {
      return update(
        state,
        {
          loadListStatus: { $set: '' },
          loadActiveStatus: { $set: '' },
          submitStatus: { $set: '' },
          list: { $set: [] },
          pagination: { $set: {} },
          active: { $set: {} },
        },
      );
    }
    default:
      return state;
  }
}
